import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import MapPanelWrapper from '../../../../components/map/MapPanelWrapper'
import { useMapActions, useMapState } from '../../../../components/map/MapContext'
import Text, { SmallText } from '../../../../packages/kiti/components/presentation/Text'
import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import NumberInput from '../../../../components/form/NumberInput'
import { useMapPointsHistoryLoader } from './_load/mapPointHistoryLoader'
import MapPointPicker from '../../../../containers/mapPoint/picker/MapPointPicker'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Form from '../../../../packages/kiti/components/form/form/Form'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import { useForm } from '../../../../packages/kiti/components/form/form/FormHandler'
import Button from '../../../../packages/kiti/components/actions/Button'

const Content = () => {
  const { t } = useTranslation('map')
  const form = useForm()
  const getHistory = useMapPointsHistoryLoader(form)
  const mapState = useMapState()
  const { setRoute } = useMapActions()
  const [isSearching, setIsSearching] = useState()
  const [error, setError] = useState()

  const onSearchHandle = () => {
    if (!form?.user?.id) {
      setError(t('selectUserError'))
      return
    }
    if (!form.pastHours) {
      setError(t('setHoursError'))
      return
    }
    setError()
    setIsSearching(true)
    getHistory().then(() => {
      setIsSearching(false)
    })
  }
  const onCleanRouteHandle = () => {
    setError()
    setRoute([])
  }
  return (
    <>
      <Grid direction={'column'}>
        <Col>
          <FormItem label={t('user')} field={'user'} Input={MapPointPicker} />
        </Col>
        <Separator weight={4} />
        <Col width="50%" wrapOn="sm">
          <FormItem label={t('lastHours')} field={'pastHours'} Input={NumberInput} />
        </Col>
      </Grid>
      <Separator weight={4} />
      {error && <SmallText color="red">{error}</SmallText>}
      <Separator weight={4} />
      <Grid justify={'space-between'} gutter={0.2}>
        <Button type={'submit'} loading={isSearching} disabled={isSearching} onClick={onSearchHandle}>
          {t('search')}
        </Button>
        <Button type={'submit'} disabled={!mapState?.route?.length} onClick={onCleanRouteHandle}>
          {t('removeRoute')}
        </Button>
      </Grid>
    </>
  )
}

const RouterPanel = () => {
  const { t } = useTranslation('map')
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <MapPanelWrapper
      title={t('route')}
      headerIcon={isOpen ? 'BsFillCaretUpFill' : 'BsFillCaretDownFill'}
      onHeaderClick={() => setIsOpen(!isOpen)}
      hasContent={!!isOpen}
      width="23rem"
    >
      {isOpen && (
        <>
          <Form initialState={{ pastHours: 1 }} padding={1}>
            <Text>{t('selectUserAndHours')}</Text>
            <Separator weight={4} />
            <Content />
          </Form>
        </>
      )}
    </MapPanelWrapper>
  )
}

export default RouterPanel
